import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AggregateUnit, FilterValues } from '@shared/services/admin-contract.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { OrganizationContractService } from '@shared/services/contract.service';
import { ToastrService } from '@shared/services/toastr.service';
import { Contract } from '../my-contracts.component';
import {
  NgbNav,
  NgbNavChangeEvent,
  NgbNavContent,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLinkBase,
  NgbNavLinkButton,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { MyContractsHeaderComponent } from '@shared/components/my-contracts-header/my-contracts-header.component';
import { ContractFiltersActionbar } from '@shared/components/contract-filters-actionbar/contract-filters-actionbar';
import { NgIf, TitleCasePipe } from '@angular/common';
import { ContractGraphsComponent } from '@shared/components/contract-graphs/contract-graphs.component';
import { ContractSitesComponent } from './contract-sites/contract-sites.component';
import { ContractClustersComponent } from './contract-clusters/contract-clusters.component';
import { TranslatePipe } from '@ngx-translate/core';
import { InvoicingFilters, InvoicingReport } from '@shared/services/abstract-contract.service';

type Tab = 'sites' | 'clusters' | 'history';

@Component({
  selector: 'app-contract-detail',
  templateUrl: './contract-detail.component.html',
  styleUrl: './contract-detail.component.scss',
  imports: [
    MyContractsHeaderComponent,
    ContractFiltersActionbar,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLinkButton,
    NgbNavLinkBase,
    NgbNavContent,
    NgIf,
    ContractGraphsComponent,
    ContractSitesComponent,
    ContractClustersComponent,
    NgbNavOutlet,
    TitleCasePipe,
    TranslatePipe,
  ],
})
export class ContractDetailComponent implements OnInit {
  @Input({ required: true }) public contract: Contract;
  @Output() public contractChange = new EventEmitter<Contract | undefined>();

  public activeTab: Tab = 'history';
  protected readonly history = history;
  public filter: InvoicingFilters;
  protected invoicingBuckets: InvoicingReport;

  public subscriptions: Subscription = new Subscription();

  public filterValues: FilterValues = {
    tags: [],
    organizations: [],
    clusters: [],
  };

  constructor(
    public contractService: OrganizationContractService,
    private toasterService: ToastrService,
  ) {}

  private readonly nbPeriods = 12;
  private readonly aggregateUnit: AggregateUnit = 'MONTH';

  ngOnInit() {
    this.subscriptions.add(
      this.contractService.getFilterValues(this.contract.number, { nbPeriods: this.nbPeriods, aggregateUnit: this.aggregateUnit }).subscribe({
        next: (list: FilterValues) => (this.filterValues = list),
        error: (err: HttpErrorResponse) => this.toasterService.error(err?.message),
      }),
    );
    this.refreshGraphs();
  }

  public onChangeFilter(value: InvoicingFilters) {
    this.filter = value;
    this.invoicingBuckets = null;
    if (this.activeTab == 'history') this.refreshGraphs();
  }

  public resetContract() {
    this.contractChange.emit(undefined);
  }

  onTabChange(event: NgbNavChangeEvent<Tab>) {
    if (event.nextId == 'history') {
      this.refreshGraphs();
    }
  }

  refreshGraphs() {
    if (!this.invoicingBuckets) {
      this.contractService
        .getInvoicingReport(this.contract.number, {
          aggregateUnit: this.aggregateUnit,
          ...this.filter,
          nbPeriods: this.nbPeriods,
        })
        .subscribe((buckets: InvoicingReport) => {
          this.invoicingBuckets = buckets;
        });
    }
  }
}
